<template>
	<div>
		<template v-if="formCreateInject">
			<van-field :required="formCreateInject.rule.validate[0].required"
				:label="formCreateInject.prop.title.title">
				<template #left-icon>
					<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
				</template>
				<template #input>
					<van-uploader @delete="onRemove" :deletable="!(disabled || readonly)" :readonly="disabled || readonly" :fileList="value"
						:max-count="limit" :multiple="multiple" :after-read="httpRequest">
						<!-- 					<template #preview-cover="{ file }">
									<div class="preview-cover van-ellipsis">{{ file.name }}</div>
								</template> -->
					</van-uploader>
				</template>
			</van-field>
		</template>
		<template v-else>
			<van-uploader @delete="onRemove" :deletable="!(disabled || readonly)" :readonly="disabled || readonly" :fileList="value" :max-count="limit"
				:multiple="multiple" :after-read="httpRequest">
			</van-uploader>
		</template>



	</div>
</template>
<style scope>
	.upload {
		flex-direction: row;
	}

	.filename {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.filethumb {
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	.icon {
		margin: 0 4px;
		font-size: 16px;
		cursor: pointer;
	}

	.button {
		width: 100%;
		height: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.preload_container {
		background-color: gray;
		box-sizing: border-box;
		padding: 20px;
	}

	.preload_box {
		background-color: white;
		width: 100%;
		min-height: 100%;
		box-sizing: border-box;
	}
</style>

<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		extends: upload,
		props: {

		},
		data() {
			return {

			}
		},
		created() {



		},
		mounted() {

		},
		watch: {
			// value(val) {
			// 	this.change(val)
			// }
		},
		computed: {

		},
		methods: {
			onRemove(obj) {
				this.change(obj)

			},
			change(obj) {
				let index = this.value.findIndex((item) => {
					return item.path == obj.path
				})
				if (index !== -1) {
					this.value.splice(index, 1)
				}
				//console.log(this.value,123123444)
				this.$emit('input', JSON.parse(JSON.stringify(this.value)))
				//this.$emit('change', JSON.parse(JSON.stringify(this.value)))
				if (this.el) {
					this.formCreateInject.api.validateField(this.formCreateInject.field)
				}
			}
		},
		components: {

		}
	}
</script>